const webExtraTranslations = {
  "Oups ! Un problème est survenu lors de la récupération des données. Veuillez vérifier votre connexion ou réessayer plus tard.": "Oops! A problem occurred while retrieving the data. Please check your connection or try again later.",
  "(du Lundi au Vendredi)": "(Monday to Friday)",
  "+ Créer une annonce": "+ Create a post",
  "À propos de Help Clic": "About Help Clic",
  "Accès interdit": "Access denied",
  Action: "Actions",
  Activer: "Enable",
  Administrateur: "Administrator",
  "Adresse du l' intervention": "Intervention address",
  Aide: "Help",
  "Ajout d'annonce": "Create a post",
  Ajouter: "Add",
  "Ajouter une réclamation": "Create a complaint",
  All: "All",
  Appel: "Call",
  Appliquer: "Apply",
  "Après avoir choisi un secteur, sélectionnez": "After choosing a sector, select",
  "Aucun fichier à visualiser": "No file to display",
  "Aucune donnée :": "No data:",
  autre: "other",
  Banque: "Bank",
  "Besoin d’un service à domicile ?": "Need a service at home?",
  "Budget max": "Maximum budget",
  "Budget Maximum": "Maximum budget",
  "Budget min": "Minimum budget",
  "Budget Minimum": "Minimum budget",
  Cacher: "Hide",
  "Catégories :": "Categories:",
  "Centre d'Aide - Votre Application": "Help Center - Your Application",
  "Champ obligatoire": "Required field",
  "Chargement de plus d'offres...": "Loading more posts...",
  "Chercher...": "Search...",
  "Chiffre d’affaire": "Revenue",
  "Choisir mes spécialités": "Choose my specialties",
  Client: "Customer",
  "Client injoignable.": "Customer cannot be reached.",
  "Code de réinitialisation": "Reset code",
  "Code Postal": "Postal code",
  Commencer: "Start",
  "Commencez à écrire le titre ou la description pour obtenir une estimation.": "Start typing the title or description to get an estimate.",
  "Complétez l'address": "Complete the address",
  "Confirmer l’intervention.": "Confirm the intervention.",
  "Contacter le": "Contact the",
  "Créez votre 1ère annonce maintenant et trouvez le professionnel qu’il vous faut en quelques clics.": "Create your first post now and find the professional you need in just a few clicks.",
  "Date Début": "Start date",
  "Date Fin": "End date",
  "Demande rejetée": "Request rejected",
  Désactiver: "Disable",
  description: "description",
  Description: "Description",
  "Description :": "Description:",
  "Désolé, nous sommes actuellement en maintenance.": "Sorry, we are currently undergoing maintenance.",
  "Détails du compte": "Account details",
  Disponible: "Available",
  "Disponible de 9h à 17h": "Available from 9 a.m. to 5 p.m.",
  "Disponible sur iOS & Android Installez pour une expérience fluide": "Available on iOS and Android. Install it for a seamless experience.",
  "Écrivez un message...": "Write a message...",
  Email: "Email",
  Engagements: "Commitments",
  Enregistrer: "Save",
  "Entrez le code de vérification": "Enter the verification code",
  "Équipe support": "Support team",
  "Erreur lors de l'envoie du code de vérification sur votre téléphone": "An error occurred while sending the verification code to your phone",
  "Erreur lors de la récupération de l'intervention": "An error occurred while retrieving the intervention",
  "Erreur lors de la récupération des conversations": "An error occurred while retrieving the conversations",
  "erreur survenue à la recuperation de la chat": "An error occurred while retrieving the chat",
  "éval(s)": "review(s)",
  "évaluation(s)": "review(s)",
  évaluations: "reviews",
  "Faites glisser et déposez n'importe quel fichier": "Drag and drop any file",
  "Faites glisser ou importez vos photos/vidéos": "Drag or upload your photos/videos",
  female: "female",
  "Fin de résultats.": "End of results.",
  Finaliser: "Complete",
  "Fréquence de paiement": "Payment frequency",
  Historique: "History",
  "Importez vos diplômes et certifications:": "Upload your diplomas and certifications:",
  "Importez votre pièce d'identité :*": "Upload your identity document:*",
  "Importez votre pièce d'identité:": "Upload your identity document:",
  "Importez votre pièce d'identité:*": "Upload your identity document:*",
  "Indiquez la catégorie": "Select the category",
  intervention: "intervention",
  "Interventions à venir": "Upcoming interventions",
  "J'ai plus besoin de l'intervention.": "I no longer need the intervention.",
  "L’adresse saisie est peut-être incorrecte ou la page a été déplacée.": "The address entered may be incorrect or the page may have moved.",
  "le champs sous Catégorie est obligatoire": "The subcategory field is required",
  "Le code de vérification a été envoyé sur votre téléphone": "The verification code has been sent to your phone",
  "Les plus récentes": "Most recent",
  "les spécialités": "specialties",
  "Liste des évaluations": "Reviews",
  "Liste des réclamations": "Complaints",
  male: "male",
  "Matricule Fiscale": "Tax registration number",
  "maximum(€)": "maximum (€)",
  "Maximum(€)": "Maximum (€)",
  "Mes compétences :": "My skills:",
  "Mes Coordonnées": "My contact details",
  "Mes documents": "My documents",
  "Mes informations": "My information",
  "Mes sous-spécialités :": "My sub-specialties:",
  "Mes spécialités :": "My specialties:",
  Messages: "Messages",
  "minimum(€)": "minimum (€)",
  "Minimum(€)": "Minimum (€)",
  "Modification de l'annonce": "Edit post",
  "Modifier mon numéro": "Change my phone number",
  "Mon compte": "My account",
  "Nbr d’interventions": "Number of interventions",
  nom: "last name",
  Non: "No",
  "Non Vérifié": "Not verified",
  "Non Vérifiée": "Not verified",
  Notifications: "Notifications",
  "Nouvelles annonces": "New posts",
  Num: "Number",
  "Numéro de téléphone": "Phone number",
  other: "other",
  ou: "or",
  Oui: "Yes",
  "Par défaut": "Default",
  "parcourez n'importe quel fichier": "browse any file",
  "Pas de présentation.": "No introduction provided.",
  "Pas de prestataires trouvés.": "No service providers found.",
  "Pas de Réclamations": "No complaints",
  Passport: "Passport",
  "Pièce d’identité": "Identity document",
  "Pièces justificatifs": "Supporting documents",
  "Plus d'offres à charger": "No more posts to load",
  "pour arranger une nouvelle date plus convenable ou annuler l'intervention": "to arrange a more suitable date or cancel the intervention",
  prénom: "first name",
  "Préparation du paiement...": "Preparing payment...",
  "Prestataire injoignable.": "Service provider cannot be reached.",
  "Prix estimé :": "Estimated price:",
  "Prix initiale": "Initial price",
  "Prix proposé :": "Proposed price:",
  Profil: "Profile",
  Publier: "Publish",
  "Raison Sociale": "Company name",
  "Raison...": "Reason...",
  "Réinitialiser votre mot de passe": "Reset your password",
  "Remonter un problème": "Report a problem",
  "Remplissez les détails": "Enter the details",
  Reporter: "Reschedule",
  "Requête incorrecte": "Invalid request",
  "Réservation de prestations": "Booking services",
  Retour: "Back",
  "Retour à l'accueil": "Back to home",
  "Retour à l’accueil": "Back to home",
  "S'inscrire": "Sign up",
  "S'inscrire avec": "Sign up with",
  "Se déconnecter": "Sign out",
  "Sécurité et confidentialité": "Security and privacy",
  "Service indisponible": "Service unavailable",
  Services: "Services",
  "Soumettre l'avis": "Submit review",
  "Sous-catégorie": "Subcategory",
  "Sous-Catégorie": "Subcategory",
  "Sous-Catégories :": "Subcategories:",
  "sous-spécialités": "sub-specialties",
  "Supprimer annonce": "Delete post",
  Technicien: "Service provider",
  "Téléverser un autre photo et/ou vidéo ?": "Upload another photo and/or video?",
  "vérification du numéro de téléphone": "Phone number verification",
  Vérifiée: "Verified",
  "Vérifier Mon numéro": "Verify my phone number",
  "Vérifiez l'email": "Verify email",
  "Veuillez sélectionner au moins une sous-catégorie": "Please select at least one subcategory",
  "Veuillez sélectionner un rôle": "Please select a role",
  Ville: "City",
  "Votre compte est en cours de vérification . Ce processus prend généralement 24h.": "Your account is being verified. This process usually takes 24 hours.",
  "Votre demande a généré une erreur.": "Your request generated an error.",
  "Vous avez déja un compte ?": "Already have an account?",
  "Vous n'avez aucune interventions à venir.": "You have no upcoming interventions.",
  "Vous n’avez pas l’autorisation de consulter cette ressource.": "You are not authorized to view this resource.",
  "Vous ne disposez pas des droits nécessaires pour accéder à cette ressource.": "You do not have the required permissions to access this resource.",
  "vue(s)": "view(s)",
  "vues)": "views)",
  "Zones d’intervention": "Intervention areas",
  "Conditions générales de vente et d'utilisation de l’application web HelpClic": "General terms and conditions of sale and use of the HelpClic web application",
  "À quoi sert l’application web HelpClic ?": "What is the HelpClic web application for?",
  "L’application web HelpClic «help-clic.fr » a été conçue pour mettre en relation des Clients avec des professionnels qui interviennent à domicile pour réaliser tous types de Prestations.": "The HelpClic web application, help-clic.fr, connects customers with professionals who provide all types of services at home.",
  "HelpClic agit uniquement en tant qu’intermédiaire médiateur entre les Clients et les prestataires de services. Il ne fournit aucune Prestation et ne fait pas partie du contrat qui lie les deux parties prenantes.": "HelpClic acts solely as an intermediary between customers and service providers. It does not provide services and is not a party to the agreement between them.",
  "Les prestataires sont sélectionnés et vérifiés par HelpClic. Ces derniers s'engagent à respecter la Charte de Qualité qui définit les compétences, le métier et le niveau de compétences attendu pour garantir des Prestations en bonne et due forme.": "Service providers are selected and verified by HelpClic. They undertake to comply with the Quality Charter, which defines the expertise, profession and skill level expected to provide services properly.",
  "De son côté, HelpClic s’engage à faciliter la mise en relation, sans être responsable des engagements contractuels nouant le Client et le prestataire.": "HelpClic undertakes to facilitate contact but is not responsible for contractual commitments between the customer and the service provider.",
  Acceptation: "Acceptance",
  "Au moment de la création de votre compte via l’application web HelpClic, qu’il s’agisse d’un prestataire ou d’un client à la recherche d’un service bien précis, l’acceptation des conditions générales de l’application est définitive, jusqu’à désinscription, suspension provisoire ou fermeture définitive de votre compte.": "When creating an account through the HelpClic web application, whether as a service provider or as a customer seeking a specific service, acceptance of the application terms is binding until deregistration, temporary suspension or permanent closure of the account.",
  "HelpClic Les clients comme les prestataires aux profils douteux et aux agissements contraires à l'éthique et à la politique de HelpClic, peuvent être bannis à jamais.": "HelpClic may permanently ban customers or service providers whose profiles are suspicious or whose conduct breaches HelpClic ethics and policies.",
  "HelpClic se réserve le droit de recenser et d’afficher les notations, effectuées par les clients, pour évaluer le prestataire de services et son intervention selon plusieurs critères. Les services de modération de l’application web HelpClic se réservent le droit de refuser la transmission de la demande d’intervention au réseau des prestataires de services si celle-ci est jugée irréalisable ou injustifiée après examen.": "HelpClic reserves the right to collect and display customer ratings assessing service providers and their work against several criteria. HelpClic moderation may refuse to distribute an intervention request to the service provider network if, after review, it is deemed unfeasible or unjustified.",
  "Un suivi post-intervention est systématiquement effectué, en plus de la modération et de la vérification continue des profils utilisateurs ; HelpClic est exclu de toute obligation de résultat.": "Post-intervention follow-up is systematically carried out in addition to moderation and continuous verification of user profiles; HelpClic is not subject to an obligation to achieve a specific result.",
  "Inscription et réservation d’intervention": "Registration and intervention booking",
  "Accédez à l’application web HelpClic « help-clic.fr »": "Go to the HelpClic web application at help-clic.fr",
  "Inscrivez-vous et créez votre compte utilisateur.": "Sign up and create your user account.",
  "Recherchez et réservez des interventions de prestataires dans de nombreuses activités disponibles sur notre plateforme :": "Search for and book service providers across the many activities available on our platform:",
  "Option 1 :": "Option 1:",
  "Déposez une annonce en tant que Client, puis sélectionnez l'offre du prestataire correspondant à vos besoins.": "Post a request as a customer, then select the service provider offer that meets your needs.",
  "Option 2 :": "Option 2:",
  "Utilisez la barre de recherche pour trouver directement le prestataire dont vous avez besoin.": "Use the search bar to find the service provider you need directly.",
  "Sélection du professionnel : Une fois le prestataire choisi, vous pourrez entamer une négociation concernant :": "Selecting the professional: once you have chosen a service provider, you can begin discussing:",
  "La nature du problème.": "The nature of the problem.",
  "Les tarifs appliqués.": "The applicable rates.",
  "Tous les détails nécessaires pour l’intervention.": "All details required for the intervention.",
  "Validation et paiement : Après accord entre les parties, effectuez le paiement pour :": "Validation and payment: once both parties agree, make the payment to:",
  "Fixer le jour et les horaires convenus.": "Set the agreed date and time.",
  "Garantie de satisfaction :": "Satisfaction guarantee:",
  "Sous 14 jours, si vous n’êtes pas satisfait, vous serez remboursé intégralement.": "Within 14 days, if you are not satisfied, you will receive a full refund.",
  "Si tout s’est déroulé comme prévu, le paiement sera transféré au prestataire.": "If everything went as planned, the payment will be transferred to the service provider.",
  "Paiement du prestataire : Le professionnel reçoit son paiement au bout de 14 jours, une fois la prestation validée par le Client.": "Service provider payment: the professional receives payment after 14 days once the service has been approved by the customer.",
  "Politique de confidentialité et réglementation qui régissent l’application web HelpClic": "Privacy policy and regulations governing the HelpClic web application",
  "HelpClic s’engage fermement et indéfiniment à protéger la confidentialité de toutes les données des utilisateurs, qu’il s’agisse des clients ou des prestataires. Cette politique garantit une gestion sécurisée et respectueuse des informations, conformément aux normes en vigueur.": "HelpClic is firmly and continuously committed to protecting the confidentiality of all user data, whether belonging to customers or service providers. This policy ensures information is handled securely and respectfully in accordance with applicable standards.",
  "La validité des présentes Conditions Générales de vente et d'utilisation de l’application web HelpClic, en fond comme en forme, est entièrement soumise à la Loi et la réglementation française en vigueur, et ce, quelle que soit la nationalité de l'intervenant.": "The validity of these General Terms and Conditions of Sale and Use of the HelpClic web application, in both substance and form, is entirely governed by current French law and regulations, regardless of the nationality of the party involved.",
  "2025 © HelpClic - Tous droits réservés - Conditions générales": "2025 © HelpClic - All rights reserved - Terms and conditions",
  "avis )": "reviews)",
  et: "and",
  "Help Clic, chez": "HelpClic, at your place",
  "vous en": "",
  "un clic!": "in one click!",
  "un compte": "an account",
  "Veuillez indiquer la nouvelle date et heure du rendez vous pour l'intervention": "Please enter the new appointment date and time for the intervention",
  "Veuillez indiquer la raison de l'annulation de l'intervention": "Please state the reason for cancelling the intervention",
};

export default webExtraTranslations;
